import { Component,Input, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LabService } from '../../../services/lab.service';
import { EventService } from '../../../services/event.services'

@Component({
  selector: 'cloudlabs-progress-card',
  templateUrl: './progress-card.component.html',
  styleUrls: ['./progress-card.component.scss']
})
export class ProgressCardComponent implements OnInit {
  @Input() labDetail: any
  // activeTab = 'validation'; // Default active tab
  activeTab
  voucherCode: string;
  labQuestions: any;
  labValidation: any;
  overallLabGuide: any

  constructor(
    private labSrv: LabService,
    private aroute: ActivatedRoute,
    private eventSrv: EventService
  ) {
    // this.aroute.params
    this.aroute.params.subscribe((i) => {
      this.voucherCode = i.voucherCode
    });
    this.eventSrv.setVoucherCode(this.voucherCode)
   }

  ngOnInit(): void {
    this.eventSrv.windowJoin.subscribe((res) => {
      this.initialLoad()
    })
    this.getLabGuideProgress()
    this.initialLoad()
  }

  initialLoad(): void {
    // this.getLabGuideProgress()
    this.activeTab = localStorage.getItem('progress-tab'+this.voucherCode) 
    ?? (this.labDetail?.EnableLabValidation ? 'validation' : 'question');
  }

  getLabGuideProgress(): void {
    this.labSrv.getLabGuideProgress(this.voucherCode).subscribe((labGuides: any) => {
      this.overallLabGuide = labGuides
      this.setActiveTab(this.activeTab, this.voucherCode)
      if (this.overallLabGuide?.TotalValidations > 0) {
        this.getLabGuideValidationProgress()
      }
      if (this.overallLabGuide?.TotalQuestions > 0) {
        this.getLabGuideQuestionProgress()
      }
    })
  }

  public setActiveTab(tab: string, voucherCode: string) {
    this.activeTab = tab;
    localStorage.setItem('progress-tab'+voucherCode, tab)
    this.eventSrv.setHeaderProgress(this.overallLabGuide.LabProgressPercentage, voucherCode)
    
  }

  getLabGuideQuestionProgress(): void {
    this.labSrv.getLabGuideQuestionProgress(this.voucherCode).subscribe((labQuestionData: any) => {
      this.labQuestions = labQuestionData
    })
  }
  
  getLabGuideValidationProgress(): void {
    this.labSrv.getLabGuideValidationProgress(this.voucherCode).subscribe((labValidationData: any) => {
      // this.labValidation = labValidationData[0].ValidationViewModels
      this.labValidation = labValidationData
      
    })
  }

}
